import {type TestIdProps, testIdProps} from '@github-ui/test-id-props'
import type {Icon} from '@primer/octicons-react'
import {Heading} from '@primer/react'
// eslint-disable-next-line primer-react/use-styled-react-import
import {Octicon} from '@primer/styled-react/deprecated'
import {clsx} from 'clsx'

import styles from './automation-block.module.css'

type AutomationBlockProps = {
  icon?: Icon
  iconBg?: string
  iconColor?: string
  headerDescription?: string
  headerEnd?: React.ReactNode
  children?: React.ReactNode
} & TestIdProps

export const AutomationBlock = ({
  icon,
  iconBg,
  iconColor,
  headerDescription,
  headerEnd,
  children,
  ...props
}: AutomationBlockProps) => {
  return (
    <div className={styles.automationBlock} {...testIdProps('automation-block')} {...props}>
      <div className={styles.blockInner}>
        <div className={clsx(styles.blockHeader, children && styles.blockHeaderWithChildren)}>
          {icon && (
            <div
              style={{
                backgroundColor: iconBg,
              }}
              className={styles.iconContainer}
            >
              <Octicon icon={icon} color={iconColor} />
            </div>
          )}
          {headerDescription && (
            <Heading as="h3" className={styles.headerDescription}>
              {headerDescription}
            </Heading>
          )}
          {headerEnd ? <div className={styles.headerEnd}>{headerEnd}</div> : null}
        </div>
        {children ? <div className={styles.blockContent}>{children}</div> : null}
      </div>
    </div>
  )
}
